/*global qq */
qq.version = "5.14.1";
